module.exports = __webpack_public_path__ + "static/front/img/expired.cf737ad0.svg";